import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { scrollToLandingSection } from "../../shared/landing-section-scroll.helper";

@Component({
  selector: "app-landing-1-cta",
  standalone: true,
  imports: [TranslateModule],
  templateUrl: "./landing-1-cta.component.html",
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Landing1CtaComponent {
  readonly dashboardUrl = input.required<string>();

  scrollToSection(sectionId: string, event: Event): void {
    scrollToLandingSection(sectionId, event);
  }
}
